<template>
  <v-container>
    <v-form ref="form" lazy-validation="">
      <v-row>
        <h1 class="title">Account Information</h1>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="accountEdit.emailAddress"
            readonly
            disabled
            label="E-mail"
            prepend-icon="mdi-email"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="accountEdit.firstName"
            :rules="firstNameRules"
            :counter="50"
            label="First name"
            required
            prepend-icon="mdi-face"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="accountEdit.lastName"
            :rules="lastNameRules"
            :counter="50"
            label="Last name"
            required
            prepend-icon="mdi-face"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="accountEdit.phoneNumber"
            :rules="phoneNumberRules"
            :counter="20"
            label="Phone number"
            required
            prepend-icon="mdi-dialpad"
            class="mx-4 my-2"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <VuetifyGooglePlaces
            :api-key="googleApiKey"
            types="address"
            country="ca"
            placeholder="Address search"
            @placechanged="getAddressData"
            searchIcon="mdi-mail"
            clearIcon="mdi-close"
            :enable-geolocation="true"
            :enable-geocode="false"
            hint="Search your address"
          ></VuetifyGooglePlaces>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="2">
          <v-text-field v-model="unitNumber" label="Unit#" class="mx-4 my-2">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="10">
          <v-text-field
            v-model="addressLineFull"
            id="addressLineFull"
            :filled="true"
            hint="Mailing Address"
            :persistent-hint="true"
            :outlined="true"
            :readonly="true"
            :clearable="true"
            @click:clear="addressClear"
            :error="!isValidMailingAddress"
            :messages="
              !isValidMailingAddress ? 'Valid Mailing address is required' : ''
            "
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="end">
        <v-btn class="my-2" color="primary" outlined @click="reset">
          Clear Values
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="mx-0 my-2" text to="/">Cancel</v-btn>
        <v-btn
          class="ml-2 my-2"
          color="primary"
          @click="submit"
          :loading="loading"
        >
          Submit
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { validationMixin, errorMessageMixin, storeMixin } from "../shared";
import { VuetifyGooglePlaces } from "vue-google-places";

export default {
  name: "Account",
  mixins: [validationMixin, errorMessageMixin, storeMixin],
  components: { VuetifyGooglePlaces },
  data: () => ({
    googleApiKey: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
    accountEdit: {},
    address: "",
    value: "",
    unitNumber: "",
    loading: false,
  }),
  async created() {
    console.log("this.account", this.account);
    if (this.isTeacher && !this.account) {
      console.log("im a teacher with no account");
      await this.loadAccount(this.$store.state.user.id);
      console.log("now this.account", this.account);
    }
    this.accountEdit = { ...this.account };
    //console.log("this.accountEdit", this.accountEdit);
  },
  computed: {
    ...mapState(["account"]),
    ...mapGetters(["isTeacher"]),
    isValidMailingAddress() {
      return (
        !!this.addressLineFull &&
        /[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} \d{1}[A-Z]{1}\d{1}, Canada/.test(
          this.addressLineFull
        )
      );
    },
    addressLineFull: {
      get: function() {
        return (this.unitNumber + (this.unitNumber ? " - " : "") + this.accountEdit.addressLine).trim();
      },
      set: function(newValue){
        this.accountEdit.addressLine = newValue;
      }
    }
  },
  methods: {
    ...mapActions([
      "updateAccountAction", 
      "logout"
    ]),
    getAddressData: function(addressData) {
      this.address = addressData;
      console.log("address", this.address);
      this.accountEdit.addressLine = addressData.formatted_address;
    },
    async submit() {
      this.$store.state.snackbar = false;
      if (this.$refs.form.validate()) {
        if (!this.isValidMailingAddress) {
          return;
        }
        this.loading = true;
        try {
          let accountModel = { ...this.accountEdit };
          accountModel.addressLine = this.addressLineFull;
          console.log("this.accountEdit", accountModel);
          await this.updateAccountAction({
            account: accountModel,
            token: this.$store.state.token
          });
          console.log("go home");
          this.$router.push({ name: "Home", params: { msg: "Account updated."}})
        }
        catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.loading = false;
      }
    },
    reset() {
      this.$refs.form.reset();
      this.addressClear();
    },
    addressClear() {
      this.unitNumber = "";
      this.accountEdit.addressLine = "";
    }
  }
}
</script>